"use client";

import { subscribeToAppSettings, type AppSettings } from "@/lib/app-settings-service";
import { useEffect, useState } from "react";

/**
 * Hook to get app settings with real-time updates
 * @returns App settings and loading state
 */
export function useAppSettings(): { settings: AppSettings; loading: boolean } {
  const [settings, setSettings] = useState<AppSettings>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Subscribe to real-time updates — onSnapshot fires immediately with current
    // data (from cache or server) and again on every subsequent change.
    // Using only the subscription avoids a race condition where a stale
    // getAppSettings() result could overwrite a more-recent subscription update.
    const unsubscribe = subscribeToAppSettings((updatedSettings) => {
      setSettings(updatedSettings);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return { settings, loading };
}

